export const ZOOM_DEFAULTS = {
  controls: true,
  wheel: true,
  startScale: 0.85,
  maxScale: 3,
  minScale: 0.3,
  scaleSpeed: 1.2,
  pinch: true,
};
